import React from 'react';
import { StyledForm, StyledSearchField, SearchButton } from './Search.styles.mjs';
import { useTheme } from 'styled-components';

const Search = ({ onSearch, className, testId }) => {
    const theme = useTheme();
    return (React.createElement(StyledForm, { onSubmit: onSearch, "data-testid": testId, className: className },
        React.createElement(StyledSearchField, { name: "search", type: "text", placeholder: "Search News12" }),
        React.createElement(SearchButton, { iconType: "search", ariaLabel: "Submit search", color: theme.colors.searchBarIconColor })));
};

export { Search as default };
//# sourceMappingURL=Search.mjs.map
